export const STATUS_SUCCESS = 'SUCCESS';
export const STATUS_ERROR = 'ERROR';
export const STATUS_PENDING = 'PENDING';
export const STATUS_NOT_SENT = 'NOT-SENT';

export const thunk = (action) => (dispatch) => {
    dispatch(action);
    return action.payload;
};